export enum TextInputVariant {
    PRIMARY = '--primary',
    READONLY = '--readonly',
    ERROR = '--error',
    DISABLED = '--disabled'
}
